'use client';

import React from 'react';

import { VariantState } from '@bytel/trilogy-react';

import { AnimcoBannerType } from '@app-types/animco';

import { PromoBanner } from '@components/promo-banner';

export type AnimcoBannerProps = {
    banner?: AnimcoBannerType | null;
};

export function AnimcoBanner({ banner }: AnimcoBannerProps) {
    if (!banner) return null;

    return (
        <PromoBanner
            text={banner.text}
            sticker={
                banner.hasDisplaySticker
                    ? {
                          value: banner.stickerValue,
                          tooltip: banner.stickerTooltip,
                          color: banner.stickerColor as VariantState,
                      }
                    : undefined
            }
        />
    );
}
